import { createSelector } from '@ngrx/store';

import { appContextFeature } from './app-context';

import { authFeature } from '@iss/wo-common/ngrx';

export const selectIsAuthorized = createSelector(
  authFeature.selectIsAuthenticated,
  appContextFeature.selectPermissionsLoaded,
  appContextFeature.selectPermissions,
  (isAuthenticated, permissionsLoaded, permissions) => {
    if (isAuthenticated == null) return undefined;
    if (!permissionsLoaded) return undefined;
    return Boolean(permissions.size);
  },
);

